import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlAuthFieldsFragment = { allocation: Types.GqlAllocationKind, authorizationGroupId: string, cashPayment: boolean, createdAt: string, id: string, inKindPayment: boolean, kind: Types.GqlAuthKind, purposeTextPl: string, purposeTextSl: string, maxRaise?: string | null, maxRaiseByAoa: boolean, offsetPayment: boolean, singleUse: boolean, updatedAt: string };

export const AuthFieldsFragmentDoc = gql`
    fragment AuthFields on Authorization {
  allocation
  authorizationGroupId
  cashPayment
  createdAt
  id
  inKindPayment
  kind
  purposeTextPl
  purposeTextSl
  maxRaise
  maxRaiseByAoa
  offsetPayment
  singleUse
  updatedAt
}
    `;